import styled from "styled-components";

const Description = styled.p`
  color: ${(props) => props.color || "var(--font1)"};
  margin: ${(props) => props.margin || 0};
  max-width: ${(props) => props.$maxWidth || "100%"};
`;

export default Description;
